import { create } from "zustand"

export const periodStore = create((set) => ({
  startDate: "",
  endDate: "",

  setStartDate: (startDate) => set({ startDate }),
  setEndDate: (endDate) => set({ endDate }),

  active: "",
  setActive: (active) => set({ active })
}))
